import * as React from "react";

export function CrossfitTableHeader(props: { children: React.ReactNode }): JSX.Element {
    return <tbody>{props.children}</tbody>;
}
